import { RefreshButton } from './RefreshButton';
import { cn } from '@/lib/utils';

/**
 * `<CategoryHeader>` — sticky column header. Carries the category display
 * label + a per-column refresh button.
 */
export interface CategoryHeaderProps {
  /** Display label, e.g. 'Dog Parks'. */
  label: string;
  /** Plural lower-case for aria-label, e.g. 'dog parks'. */
  pluralLower: string;
  onRefresh: () => void;
  pending?: boolean;
}

export function CategoryHeader({
  label,
  pluralLower,
  onRefresh,
  pending = false,
}: CategoryHeaderProps) {
  return (
    <th
      scope="col"
      className={cn(
        'sticky top-16 z-30',
        'p-3 text-left text-sm font-semibold text-foam-50 bg-ocean-900/95 border border-white/5',
      )}
    >
      <div className="flex items-center justify-between gap-3">
        <span>{label}</span>
        <RefreshButton
          ariaLabel={`Refresh ${pluralLower} across all counties`}
          onClick={onRefresh}
          pending={pending}
        />
      </div>
    </th>
  );
}
